module.exports = __webpack_public_path__ + "img/30290-7.prt.3e6605ca.jpg";